<template>
  <div class="chargeback">
    <div class="main-filter">
      <div class="filter">
        <div>
          <el-input
            v-model="query.filter"
            class="search-name input-with-select"
            reserve-keyword
            clearable
            :placeholder="searchText"
            @clear="getReservationList"
            @keyup.enter.native="enterSearch"
          >
            <el-select
              v-model="searchText"
              slot="prepend"
              placeholder="全文搜索"
              @change="filterSelect"
            >
              <el-option label="楼盘名称" value="请输入楼盘名称"></el-option>
              <el-option label="客户姓名" value="请输入客户姓名"></el-option>
              <el-option
                label="全文搜索"
                value="请输入楼盘名称/客户名称"
              ></el-option>
            </el-select>
          </el-input>
          <el-button
            type="primary"
            @click="getReservationList"
            class="filter-btn"
            >查询</el-button
          >
          <el-button type="text" class="delete-btn" @click="deleteFilter"
            ><i class="el-icon-delete el-icon--right"></i>清空全部</el-button
          >
        </div>
      </div>
      <div class="filter-select">
        <div class="filter-item">
          <span class="filter-tit">楼盘</span>
          <el-select
            v-model="query.estateName"
            @change="estateNameChange"
            filterable
            remote
            @visible-change="estateVisibleChange"
            :remote-method="getEstates"
            @clear="estates = []"
            placeholder="请输入楼盘名称/地址"
            clearable
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in estates"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">经纪人</span>
          <el-select
            v-model="query.brokerName"
            placeholder="请输入经纪人姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getUsersSearch"
            @visible-change="userVisibleChange"
            @change="getBroker"
            :no-data-text="noDataText"
            @clear="creatorlist = []"
          >
            <el-option
              v-for="item in creatorlist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">渠道</span>
          <el-select
            v-model="query.channelName"
            placeholder="请输入渠道人员姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getChannelSearch"
            @visible-change="channelVisibleChange"
            @change="getChannel"
            :no-data-text="noDataText"
            @clear="channellist = []"
          >
            <el-option
              v-for="item in channellist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">门店</span>
          <el-select
            v-model="query.organizationUnit"
            @change="getOrganizationUnit"
            filterable
            remote
            :remote-method="getOrgs"
            @visible-change="orgVisibleChange"
            @clear="orgList = []"
            placeholder="请输入门店名称"
            :no-data-text="noDataText"
            clearable
          >
            <el-option
              v-for="item in orgList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex filter-item">
          <span class="filter-tit">退单日期</span>
          <el-date-picker
            v-model="refundDaterange"
            type="daterange"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getReservationList"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <el-table :data="reservationList" border>
      <el-table-column
        label="楼盘名称"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="todetails" @click="toEstate(scope.row.estateId)">{{
            scope.row.estateName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户" :resizable="false" align="left">
        <template slot-scope="scope">
          <span class="todetails">{{
            scope.row.customerName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="经纪人" :resizable="false" align="left">
        <template slot-scope="scope">
          {{ scope.row.creatorName | nullValue }}
        </template>
      </el-table-column>
      <el-table-column
        label="渠道"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.channelName | nullValue
          }}<span v-if="scope.row.channelOrganizationUnit"
            >({{ scope.row.channelOrganizationUnit | nullValue }})</span
          >
        </template>
      </el-table-column>
      <el-table-column label="退单日期" :resizable="false" align="left">
        <template slot-scope="scope">
          {{ scope.row.lastRefundTime | nullValue }}
        </template>
      </el-table-column>
      <el-table-column label="状态" :resizable="false" align="left">
        <template slot-scope="scope">
          {{ scope.row.flowStatus | nullValue }}
          <span
            v-if="scope.row.reviewStatus"
            :class="
              scope.row.reviewStatus == '已通过'
                ? 'success'
                : scope.row.reviewStatus == '已驳回'
                ? 'error'
                : 'waiting'
            "
            >（{{
              scope.row.reviewStatus == "已通过"
                ? "已退"
                : scope.row.reviewStatus
            }}）</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" :resizable="false" align="left">
        <template slot-scope="scope">
          <span class="theme-color" @click="goDetail(scope.row)">详情</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="loading-box" v-if="isLoading">
          <img
            src="@/assets/image/loading.png"
            alt="loading"
            class="loading-ico"
          />
          数据加载中...
        </div>
        <div class="empty-box" v-if="!isLoading && !reservationList.length">
          列表为空
        </div>
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageIndex"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="query.maxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>

<script>
import { getReservations } from "@/http/api/reservations";
import { getUsersSearch } from "@/http/api/employe";
import { dateFormat } from "@/common/filters";
import { getOrgsSearch } from "@/http/api/organization";
import { getEstates } from "@/http/api/estate";
export default {
  data() {
    return {
      reservationList: [],
      isLoading: true,
      pageIndex: 1,
      totalCount: 0,
      searchText: "请输入楼盘名称/客户名称",
      noDataText: "无数据",
      search: "",
      refundDaterange: [],
      query: {
        estateName: "",
        channelName: "",
        brokerName: "",
        organizationUnit: "",
        brokerId: "",
        channelId: "",
        organizationUnitId: "",
        estateId: "",
        filter: "",
        flowStatus: "",
        maxResultCount: 30,
        isRefund: true,
        skipCount: 0,
        condition: "",
      },
      creatorlist: [],
      channellist: [],
      searchOptions: [
        {
          value: "estateName",
          label: "楼盘名称",
        },
        {
          value: "customerName",
          label: "客户名称",
        },
      ],
      orgList: [],
      estates: [],
    };
  },
  mounted() {
    let obj = this.$route.params.obj;
    if (obj) {
      obj = JSON.parse(obj);
      this.refundDaterange = [obj.startTime, obj.endTime];
      this.query.estateId = obj.estateId;
      this.query.estateName = obj.estateName;
      this.query.organizationUnitId = obj.organizationUnitId;
      this.query.organizationUnit = obj.organizationUnit;
      this.query.channelId = obj.channelId;
      this.query.channelName = obj.channelName;
      this.query.brokerId = obj.brokerId;
      this.query.brokerName = obj.brokerName;
    }
    this.getReservationList();
  },
  methods: {
    goDetail(v) {
      this.$router.push({ path: `/reservation/detail/${v.id}`,query:{refund:true} });
    },
    getBroker(v) {
      this.query.brokerId = v;
      this.getReservationList();
    },
    getChannel(v) {
      this.query.channelId = v;
      this.getReservationList();
    },
    getOrganizationUnit(v) {
      this.query.organizationUnitId = v;
      this.getReservationList();
    },
    estateNameChange(v) {
      this.query.estateId = v;
      this.getReservationList();
    },
    estateVisibleChange(v) {
      if (!v) {
        this.estates = [];
      }
    },
    getEstates(v) {
      if (v) {
        let query = {
          filter: v,
          condition: "name",
          maxResultCount:30,
        };
        this.noDataText = "加载中...";
        getEstates(query)
          .then((res) => {
            if (res && res.result) {
              this.estates = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.estates = [];
      }
    },
    orgVisibleChange(v) {
      if (!v) {
        this.orgList = [];
      }
    },
    channelVisibleChange(v) {
      if (!v) {
        this.channellist = [];
      }
    },
    userVisibleChange(v) {
      if (!v) {
        this.creatorlist = [];
      }
    },
    getOrgsSearch(v) {
      this.orgList = [];
      let query = {
        filter: v,
        maxResultCount:30,
      };
      this.noDataText = "加载中...";
      getOrgsSearch(query)
        .then((res) => {
          this.orgList = res.result.items;
          this.noDataText = "无数据";
        })
        .catch(() => {
          this.noDataText = "无数据";
        });
    },
    getOrgs(query) {
      if (query) {
        this.getOrgsSearch(query);
      } else {
        this.orgList = [];
      }
    },
    //获取经纪人
    getUsersSearch(e) {
      if (e) {
        var params = {
          filter: e,
          maxResultCount: 30,
        };
        let query = "";
        for (var key in params) {
          if (params[key] !== null && params[key] !== "") {
            query = `${key}=${params[key]}&${query}`;
          }
        }
        this.noDataText = "加载中...";
        getUsersSearch(query)
          .then((res) => {
            if (res.code == 10200) {
              this.creatorlist = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.creatorlist = [];
      }
    },
    getChannelSearch(e) {
      if (e) {
        var params = {
          filter: e,
          maxResultCount: 30,
        };
        let query = "";
        for (var key in params) {
          if (params[key] !== null && params[key] !== "") {
            query = `${key}=${params[key]}&${query}`;
          }
        }
        this.noDataText = "加载中...";
        getUsersSearch(query)
          .then((res) => {
            if (res.code == 10200) {
              this.channellist = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.channellist = [];
      }
    },
    toEstate(id) {
      this.$router.replace(`/estate/detail/${id}`);
    },
    deleteFilter() {
      Object.assign(this.$data.query, this.$options.data().query);
      this.refundDaterange = [];
      this.getReservationList();
    },
    // 搜索前置条件
    filterSelect(val) {
      if (val == "请输入楼盘名称") {
        this.query.condition = "estateName";
      } else if (val == "请输入客户姓名") {
        this.query.condition = "customerName";
      } else {
        this.query.condition = "";
      }
    },
    enterSearch() {
      var evt = window.event || e;
      if (evt.keyCode == 13) {
        // 回车事件
        this.getReservationList();
      }
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.pageIndex = 1;
      this.getReservationList();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReservationList();
    },
    getReservationList() {
      let query = {
        maxResultCount: this.query.maxResultCount,
        skipCount: (this.pageIndex - 1) * this.query.maxResultCount,
        isRefund: true,
      };
      if (this.refundDaterange && this.refundDaterange.length) {
        query.lastRefundStartTime = dateFormat(this.refundDaterange[0]);
        query.lastRefundEndTime = dateFormat(this.refundDaterange[1]);
      }
      if (this.query.condition) {
        query.condition = this.query.condition;
      }
      if (this.query.filter) {
        query.filter = this.query.filter;
      }
      if (this.query.brokerId) {
        query.brokerId = this.query.brokerId;
      }
      if (this.query.channelId) {
        query.channelId = this.query.channelId;
      }
      if (this.query.estateId) {
        query.estateId = this.query.estateId;
      }
      if (this.query.organizationUnitId) {
        query.organizationUnitId = this.query.organizationUnitId;
      }
      this.isLoading = true;
      this.reservationList = [];
      getReservations(query)
        .then((res) => {
          this.reservationList = res.result.items;
          this.totalCount = res.result.totalCount;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.chargeback {
  .main-filter {
    .filter {
      @include flex(row, center);
      justify-content: space-between;
      margin-bottom: 20px;

      ::v-deep .input-with-select {
        margin-right: 20px;
        width: 440px;
        .el-input-group__prepend {
          width: 110px;
          .el-input__inner {
            width: 110px;
          }
        }
        .el-input__inner {
          width: 270px;
        }
      }
      .filter-type {
        width: 160px;
      }
      .filter-btn {
        margin-right: 10px;
      }
      .delete-btn {
        color: #717171;
      }
      .el-icon-delete {
        margin-right: 5px;
      }
    }
    .filter-select {
      @include flex(row, center);
      flex-wrap: wrap;
      margin-left: -20px;
      .filter-tit {
        margin: 0 20px;
        color: #717171;
      }
      .filter-item {
        margin-bottom: 20px;
      }
    }
  }

  ::v-deep .el-tabs {
    border: 0px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);

    .el-tabs__item {
      margin-right: 12px;
      padding: 0 30px;
      border-radius: 4px 4px 0 0;
      border-bottom: 0;
      height: 40px;
      line-height: 40px;
      color: #333;
      background: #f7f7f7;
      &:hover {
        color: #fff;
        background: $--color-primary;
        opacity: 0.9;
      }

      &:nth-child(2) {
        padding-left: 30px;
      }

      &:last-child {
        padding: 0 22px;
      }
    }
    .is-active {
      border-bottom: 0;
      color: #fff;
      background: $--color-primary;
    }
    .el-tabs__nav-scroll {
      padding-left: 0;
      border-bottom: 1px solid $--color-primary;
    }
    .el-tabs__header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);
    }
  }
  .el-table {
    margin-bottom: 40px;
    .success {
      color: #74c55c;
    }
    .error {
      color: #999;
    }
    .waiting {
      color: #409eff;
    }
    .todetails {
      color: $--color-primary;
      cursor: pointer;
    }
  }
}
</style>
